if (!customElements.get("f-cart-goal")) {
  class FCartGoal extends HTMLElement {
    constructor() {
      super();

      this.selectors = {
        cartDrawer: ".f-cart-drawer__inner",
        leftToSpend: "[data-left-to-spend]",
        cartGoalTitle: ".f-cartgoal__title",
      };

      this.confettiShow = false;
      this.goalDone = false;
      this.goal =
        Number(this.dataset.cartGoal) *
          Number(window.Shopify.currency.rate || 1) || 0;
      this.money_format = window.FoxThemeSettings.money_format;
      this.enableConfetti = this.dataset.enableConfetti === "true";
    }

    connectedCallback() {
      this.updateCartGoal(Number(this.dataset.cartTotal));
      window.FoxThemeEvents.subscribe(PUB_SUB_EVENTS.cartUpdate, (state) => {
        this.updateCartGoal(state.items_subtotal_price);
      });
      window.FoxThemeEvents.subscribe(PUB_SUB_EVENTS.cartUpdate, async () => {
        const newCart = await window.FoxThemeCartHelpers.getState();
        if (newCart) {
          this.updateCartGoal(newCart.items_subtotal_price);
        }
      });
      this.confettiShow = this.goalDone;
    }

    updateCartGoal(state) {
      if (state > 0) {
        this.classList.remove("hidden");
      } else {
        this.classList.add("hidden");
      }

      this.cartTotal = state / 100;
      this.goalLeft = this.goal - this.cartTotal;
      this.goalDone = this.goalLeft <= 0;

      this.percent = (this.cartTotal * 100) / this.goal;

      if (this.percent >= 100) this.percent = 100;

      if (this.cartTotal >= this.goal) {
        this.style.setProperty("--progress", `${this.percent}%`);
        this.classList.add("f-cartgoal--done", "shakeY");
        this.dataset.total = this.cartTotal;
      } else {
        let spend = (this.goal - this.cartTotal) * 100;
        this.querySelector(this.selectors.leftToSpend).innerHTML = formatMoney(
          spend,
          this.money_format
        );
        this.classList.remove("f-cartgoal--done", "shakeY");
        this.style.setProperty("--progress", `${this.percent}%`);
        this.dataset.total = this.cartTotal;
      }

      if (this.goalLeft <= 0 && this.enableConfetti) {
        this.showConfetti();
      } else {
        this.confettiShow = false;
      }
    }

    showConfetti() {
      const cartDrawer = this.closest(this.selectors.cartDrawer);
      const cartTemplate = this.closest(".cart-template");

      if (!this.confettiShow && (cartDrawer || cartTemplate)) {
        setTimeout(() => {
          if (cartDrawer) {
            new window.FoxTheme.Confetti(cartDrawer);
          }
          if (cartTemplate) {
            new window.FoxTheme.Confetti(document.body);
          }
          this.confettiShow = true;
        }, 800);
      }
    }
  }

  customElements.define("f-cart-goal", FCartGoal);
}

/* Relabel checkout button when the minimum-order app swaps its text.
   The app still disables/blocks checkout below the minimum - only the label changes. */
(function () {
  var LABEL = "Check Out";
  var PATTERN = /order value|must exceed|minimum/i;
  function fix() {
    var btns = document.querySelectorAll('button[name="checkout"], input[name="checkout"], a[href="/checkout"], [id*="mincart" i] button, button[class*="mincart" i], [class*="mincart" i] button');
    for (var i = 0; i < btns.length; i++) {
      var btn = btns[i];
      var txt = (btn.tagName === "INPUT" ? btn.value : btn.textContent) || "";
      if (PATTERN.test(txt)) {
        if (btn.tagName === "INPUT") btn.value = LABEL;
        else btn.textContent = LABEL;
      }
    }
  }
  function start() {
    fix();
    new MutationObserver(fix).observe(document.documentElement, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ["value", "disabled"]
    });
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();

/* Minimum-order checkout guard.
   Below the minimum, block the checkout click (including the MinCart app's own
   swapped-in button) before the app's popup can open, and bounce the
   "Add $X more to meet..." cart-goal message instead. */
(function () {
  var style = document.createElement("style");
  style.textContent =
    "@keyframes fCartGoalBounce{0%,100%{transform:translateY(0)}20%{transform:translateY(-12px)}40%{transform:translateY(0)}55%{transform:translateY(-7px)}70%{transform:translateY(0)}85%{transform:translateY(-3px)}}" +
    ".f-cartgoal--bounce .f-cartgoal__title{animation:fCartGoalBounce .8s ease both;}";
  document.head.appendChild(style);

  var SELECTOR = 'button[name="checkout"], input[name="checkout"], a[href*="/checkout"], [id*="mincart" i], [class*="mincart" i]';

  function getGoalEl(btn) {
    var scope = btn.closest(".f-cart-drawer__inner") || btn.closest(".cart-template") || btn.closest("#main-cart-footer");
    if (scope) {
      var el = scope.querySelector("f-cart-goal");
      if (el) return el;
    }
    return document.querySelector("f-cart-goal");
  }

  function guard(e) {
    var btn = e.target && e.target.closest && e.target.closest(SELECTOR);
    if (!btn) return;
    var goalEl = getGoalEl(btn);
    if (!goalEl) return;
    var goal = Number(goalEl.dataset.cartGoal) * Number((window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1) || 0;
    var total = goalEl.dataset.total !== undefined ? Number(goalEl.dataset.total) : Number(goalEl.dataset.cartTotal) / 100;
    if (goal > 0 && total < goal) {
      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();
      if (e.type === "click") {
        goalEl.classList.remove("f-cartgoal--bounce");
        void goalEl.offsetWidth;
        goalEl.classList.add("f-cartgoal--bounce");
        if (goalEl.scrollIntoView) goalEl.scrollIntoView({ block: "nearest", behavior: "smooth" });
      }
    }
  }

  ["pointerdown", "mousedown", "touchstart", "click"].forEach(function (evt) {
    window.addEventListener(evt, guard, true);
  });
})();
